import React from 'react'
import isEmpty from 'lodash/isEmpty'

import * as styles from './headline.module.scss'

const Headline = ({ label, headline }) => {
  if (isEmpty(headline)) return <></>

  return (
    <div className={styles.intro}>
      <div className={styles.label}>{label}</div>
      <div>{headline}</div>
    </div>
  )
}

export default Headline
